import i18n from '../../i18n'
import noSpaceRules from './noSpaceRules'

const jdbcURLRegex = /jdbc:([^:]+):/

const jdbcURLRule = (v) => jdbcURLRegex.test(v) || `${i18n.t('warnings.validation.url')} jdbc:postgresql://255.192.0.144:5432/postgres;databaseName=homolog;`

const databaseURLRules = (v) => [
  ...noSpaceRules(v),
  jdbcURLRule(v)
]

export default databaseURLRules
